import { render, staticRenderFns } from "./yichang-list.vue?vue&type=template&id=9bbb3ef0&"
import script from "./yichang-list.vue?vue&type=script&lang=ts&"
export * from "./yichang-list.vue?vue&type=script&lang=ts&"
import style0 from "./yichang-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports